module.exports = __webpack_public_path__ + "img/motors.0959757c.svg";